import CryptoJS from 'crypto-js';
import { SECRET_KEY } from '../services/const';
import { getConfig, getInternalToken } from '../services/auth.service';

export const encrypt = (text: string): string => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(text), SECRET_KEY).toString();
    return encrypted.toString();
};

const getNewUserToken = async (id: string) => {
    try {
        const internalTokenRes = await getInternalToken(id);
        if (internalTokenRes?.statusCode !== 200 || !internalTokenRes?.data?.internalUUID) return false;

        const configRes = await getConfig(internalTokenRes.data.internalUUID);
        if (configRes?.statusCode !== 200 || !configRes?.data?.config) return false;

        const { config } = configRes.data;
        sessionStorage.setItem("config", JSON.stringify(config));
        sessionStorage.setItem("userId", config.userId || '');
        sessionStorage.setItem("chartId", config.chartId || '');

        return true;
    } catch (error) {
        console.error("Error fetching new user token:", error);
        return false;
    }
};

export const checkAndUpdateUserToken = async () => {
    const userId = sessionStorage.getItem("userId") || "";
    const id = sessionStorage.getItem("id") || "";
    
    if (!id) return false;

    try {
        if (!userId) return await getNewUserToken(id);

        const payloadBase64 = userId.split('.')[1];
        const payload = JSON.parse(atob(payloadBase64));
        const exp = payload.exp;
        const currentTime = Math.floor(Date.now() / 1000);
        if (exp - currentTime <= 300) {
            console.log("Token is expired or about to expire, fetching a new one...", currentTime, exp);
            return await getNewUserToken(id);
        }

        return true;
    } catch (err) {
        console.error("Error checking user token:", err);
        return false;
    }
};